import React from 'react';
import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const styles = theme => ({

});

const MaxFavouritesReachedModal = ({ open, onClose, category, max }) => (
  <Dialog
    disableRestoreFocus={true}
    open={Boolean(open)}
    onClose={onClose}
    maxWidth="sm" fullWidth>
    <DialogTitle>Max number of favourites reached</DialogTitle>
    <DialogContent>
      <DialogContentText>The maximum number of favourites is {max}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

export default withStyles(styles)(MaxFavouritesReachedModal);

